export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14858.e9460ed6.jpg";